import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const SessionExpiredModal = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handler = () => setShow(true);
        window.addEventListener('session-expired', handler);
        return () => window.removeEventListener('session-expired', handler);
    }, []);

    const handleRefresh = () => {
        Cookies.remove("access_token");
        window.location.href = '/login';
    };

    if (!show) return null;

    return (
        <div style={{
            position: 'fixed', inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999
        }}>
            <div style={{
                background: 'white', borderRadius: 12,
                padding: 32, maxWidth: 360, textAlign: 'center'
            }}>
                <h3>Sesi Telah Berakhir</h3>
                <p style={{ color: '#666', margin: '12px 0 24px' }}>
                    Sesi login Anda telah berakhir. Silakan login ulang untuk melanjutkan.
                </p>
                <button onClick={handleRefresh} style={{
                    background: '#1890ff', color: 'white',
                    border: 'none', borderRadius: 8,
                    padding: '10px 24px', cursor: 'pointer', fontSize: 14
                }}>
                    Login Ulang
                </button>
            </div>
        </div>
    );
};

export default SessionExpiredModal;